import { Component, input, inject, viewChild, output, signal, effect } from '@angular/core';
import { ToolUsersRegistration, UserToolsRegistration } from '../../../utils/models/tool.models';
import { ToolService } from '../../../services/api-services/tools/tool.service';
import { UserService } from '../../../services/api-services/user.service';
import { ToolchainUsersRegistration } from '../../../utils/models/toolchain.models';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { FormsModule } from '@angular/forms';

export type RegistrationItem = {
  id: number;
  name: string;
};

@Component({
  selector: 'app-registration-list',
  templateUrl: './registration-list.component.html',
  styleUrls: ['./registration-list.component.scss'],
  imports: [MatSelectionList, FormsModule, MatListOption],
})
export class RegistrationListComponent {
  /** Inject services. */
  private readonly toolService = inject(ToolService);
  private readonly userService = inject(UserService);

  readonly selectionList = viewChild.required<MatSelectionList>('selectionList');

  readonly userRegistration = input<UserToolsRegistration>();
  readonly toolRegistration = input<ToolUsersRegistration>();
  readonly toolchainRegistration = input<ToolchainUsersRegistration>();

  users = this.userService.getAllUsers();
  tools = this.toolService.getAllToolsAdmin();
  items = signal<RegistrationItem[]>([]);
  selectedItems = signal<number[]>([]);

  readonly newItemEvent = output<number[]>();

  constructor() {
    effect(() => {
      let selectedItems: number[] | undefined = undefined;
      let items: RegistrationItem[] | undefined = undefined;
      if (this.userRegistration()) {
        selectedItems = this.userRegistration()?.tools.map(tool => tool.toolId);
        items = this.tools.value()?.map(tool => ({ id: tool.toolId, name: tool.name }));
      } else if (this.toolRegistration()) {
        selectedItems = this.toolRegistration()?.users.map(user => user.userId);
        items = this.users.value()?.map(user => ({ id: user.userId, name: user.userName }));
      } else if (this.toolchainRegistration()) {
        selectedItems = this.toolchainRegistration()?.users.map(user => user.userId);
        items = this.users.value()?.map(user => ({ id: user.userId, name: user.userName }));
      }
      this.items.set(items ?? []);
      selectedItems ??= [];
      this.selectedItems.set(selectedItems);
      this.newItemEvent.emit(selectedItems);
    });
  }

  changeSelectedTools() {
    const selectedValues = this.selectionList().selectedOptions.selected.map(
      option => option.value
    );
    this.newItemEvent.emit(selectedValues);
  }
}
